import { shouldTrack } from '$lib/global/tracking/helper';

import { getQueue, send } from './queue';

export const track = (data: any) => {
    data.type = 'track';

    return enqueue('/t', data);
};

export const page = (data: any) => {
    data.type = 'page';

    return enqueue('/p', data);
};

export const identify = (data: any) => {
    data.type = 'identify';

    return enqueue('/i', data);
};
export const enqueue = (path: string, message: any) => {
    if (!shouldTrack()) {
        return;
    }

    const url = `/ps-fnl-events/api/data${path}`;

    const queue = getQueue();

    // Send the request directly first with a timeout.
    send(
        message,
        url,
        (err: { status: string; responseText: string }) => {
            if (err) {
                const lastPart = url.split('/').reverse()[0];
                console.warn(`Direct Tracking Error: /${lastPart} - ${err.status}`, {
                    data: {
                        url,
                        message,
                        error: JSON.stringify(err),
                        status: err.status,
                        responseText: err.responseText,
                    },
                });

                // On failure, add to the queue for retry.
                queue.addItem({
                    url,
                    message,
                });
            }
        },
        1000,
    ); // Timeout set to 1 seconds, normal response time is 100-200ms
};

export default {
    track,
    page,
    identify,
};
